import {Component, input} from '@angular/core';
import {BluetoothSvgComponent, Status} from "src/app/presentation/common/icons/bluetooth-svg/bluetooth-svg.component";

@Component({
  selector: 'app-proximity-point-marker',
  imports: [
    BluetoothSvgComponent
  ],
  templateUrl: './proximity-point-marker.component.html',
  styleUrl: './proximity-point-marker.component.css'
})
export class ProximityPointMarkerComponent {

  iconName = input('');
  status = input(Status.OFFLINE);
}
